import React, { useState } from 'react';
import { Divider, Input, Select, DatePicker } from 'antd';
import CustomContent from '../../components/Content/CustomContent';
import ActivityPage from '../dashboard/Activity/ActivityPage';

const { Option } = Select;
const { Search } = Input;
const { RangePicker } = DatePicker;

const ActivityList = () => {

  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const onDateChange = (date, dateString) => {
    if (dateString[0] !== '' && dateString[1] !== '') {
      setFrom(dateString[0] + ' 00:00:00');
      setTo(dateString[1] + ' 00:00:00')
    } else {
      setFrom(null)
      setTo(null)
    }
  };

  return (
    <CustomContent>
      <RangePicker
        onChange={onDateChange}
        style={{ float: 'right', marginBottom: 16 }}
      />
      <Divider />
      <ActivityPage
        from={from}
        to={to}
      />
    </CustomContent>
  );
};

export default ActivityList;
